export const AVAILABILITY_STATUS = {
  CLOSED: 2,
  AVAILABLE: 1,
  UNAVAILABLE: 0
};

// NOTE: This constant is used to denote the Anytime option from the Time dropdown
export const ANYTIME = -1;
